export default "__VITE_ASSET__7026984b__"